module.exports = __webpack_public_path__ + "static/media/u272.8594f65c.svg";